import React, { useContext, useEffect, useState } from "react";
import ReactDOM from "react";

import { Loading } from "../SVG";
import NoticeN2 from "./NoticeN2";
import NoticeTable from "./NoticeTable";
import { HibModal } from "../HibModal"
import WebServiceContext from "../../webService/WebServiceContext";
import PDFContent from "./PDFContent";

/*
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
*/


/*
type CardProps = {
    title:string
    type?:string
    children?: String | React.ReactNode
}
*/


type NoticeObj = {
    RecordCount: number
    TypeName: string
    currentYear?:number
    //isOpen: boolean
}

const Notice = () => {
    const ws = useContext(WebServiceContext)
    const [noticeData, setNoticeData] = useState<NoticeObj[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [current, setCurrent] = useState<number>(-1)
    const [collapseList, setCollapseList] = useState<boolean[]>([])
    const [isOpen, setIsOpen] = useState<boolean>(false)
    
    const [PDFfileName, setPDFfileName] = useState<string>("")

    useEffect(() => {
        ws.webservice.asyncPerformance("通知件數").then(res => {
            //console.log(res)
            setNoticeData(res as NoticeObj[])
            setIsLoading(false)
        })

        return
    }, [])

    const openContent = (index: number) => {
        let _list:boolean[] = []
        if(!collapseList[index]){
            _list[index] = true
        }   
        setCollapseList(_list)
        setCurrent(index)
    }
   
    const renderBox = (index:number, name: React.ReactNode, content: React.ReactNode )=>
        <div className="collapse-box" >
            <button className={"collapse-btn " + (collapseList[index] ? "on":"")}  onClick={()=>{openContent(index)}}>
                {name}
            </button>
            <div className={"collapse-content " + (collapseList[index] ? "on":"")} >
                {content}
            </div>
        </div>
        
    const LRBox =( left: React.ReactNode, right: React.ReactNode)=>    
        <span className="LRbox">
            <span className="Lbox">
                {left}
            </span>
            <span className="Rbox">
                {right}
            </span>
        </span>
    
    
    const openModalAndRenderPdf = (fileName:string)=>{
        setIsOpen(true)
        setPDFfileName(fileName)
    }
    

    if (isLoading) {
        return <Loading />
    } else {
        return (
            <>
                {/* PDF顯示彈跳視窗 */}
                <HibModal 
                    cancel={()=>{ setIsOpen(false)}}
                    show={isOpen}
                    children={<PDFContent fileName={PDFfileName}/>}
                />
                
                <div className="hib-collapse card-content">
                    {
                        noticeData.length > 0 &&
                        <>
                            {
                                //noticeData[0].RecordCount > 0 &&
                                renderBox(
                                    0,
                                    LRBox(
                                        "停效 墊繳 催吿 失效",
                                        <div className="countIcon color-0">
                                            {noticeData[0]?.RecordCount}
                                        </div>
                                    )
                                    ,
                                    <NoticeTable type="停效墊繳催吿失效" />
                                )
                            }
                            {
                                
                                //noticeData[1].RecordCount > 0 &&
                                renderBox(
                                    1,
                                    LRBox(
                                        "續期轉帳失敗及其他通知",
                                        <div className="countIcon color-1">
                                            {noticeData[1]?.RecordCount}
                                        </div>
                                    ),
                                    <NoticeN2 />
                                )
                            }
                            {
                                
                                //(noticeData[3].RecordCount + noticeData[4].RecordCount) > 0 &&
                                renderBox(
                                    2,
                                    LRBox(
                                        "保單未發單明細(六個月)",
                                        <>
                                            壽
                                            <div className="countIcon color-3">
                                                {noticeData[3]?.RecordCount}
                                            </div>
                                            產
                                            <div className="countIcon color-4">
                                                {noticeData[4]?.RecordCount}
                                            </div>
                                        </>
                                    ),
                                    <NoticeTable type="保單未發單明細" />
                                )
                            }
                            {
                                //(noticeData[7].RecordCount + noticeData[8].RecordCount) > 0 &&
                                renderBox(
                                    3,
                                    LRBox(
                                        "新契約補全(二個月)",
                                        <>
                                            壽
                                            <div className="countIcon color-7">
                                                {noticeData[7]?.RecordCount}
                                            </div>
                                            產
                                            <div className="countIcon color-8">
                                                {noticeData[8]?.RecordCount}
                                            </div>
                                        </>
                                    ),
                                    <NoticeTable type="新契約補全" modalPDF={openModalAndRenderPdf}/>
                                )
                            }
                            {
                                //noticeData[2].RecordCount > 0 &&
                                renderBox(
                                    4,
                                    LRBox(
                                        "簽收單回條未回",
                                        <div className="countIcon color-2">
                                            {noticeData[2]?.RecordCount}
                                        </div>
                                    ),
                                    <NoticeTable type="簽收單回條未回" />
                                    )
                                }
                            {
                                //(noticeData[5].RecordCount + noticeData[6].RecordCount) > 0 &&
                                renderBox(
                                    5,
                                    LRBox(
                                        "最近5日報件",
                                        <>
                                            壽
                                            <div className="countIcon color-5">
                                                {noticeData[5]?.RecordCount}
                                            </div>
                                            產
                                            <div className="countIcon color-6">
                                                {noticeData[6]?.RecordCount}
                                            </div>
                                        </>
                                    ),
                                    <NoticeTable type="最近5日報件" />
                                )
                            }
                            {
                                //noticeData[9].RecordCount > 0 &&
                                renderBox(
                                    6,
                                    LRBox(
                                        "保全照會(一個月)",
                                        <div className="countIcon  color-9">
                                            {noticeData[9]?.RecordCount?noticeData[9].RecordCount:0}
                                        </div>
                                    ),
                                    <NoticeTable type="保全照會" modalPDF={openModalAndRenderPdf}/>
                                )
                            }
                        </>
                    
                    }
                </div>
            </>
        )
    }
}

export default Notice